import { luminate, saturate } from 'everyday-utils'
import { Rect } from 'geometrik'
import { skin } from './skin'
import { Slider } from './slider'
// import { USER_IDLE_MS, users } from './ws'

export class Knob<T = any> {
  index = -1
  value = 0
  min = 0
  max = 1
  slope = 1
  step = 0.01
  active = false
  hover = false
  rect = new Rect()
  slider?: Slider

  meta?: T

  activeFillStyle = saturate(luminate(skin.$.colors.bg, 0.5), 0.6)
  activeStrokeStyle = saturate(luminate(skin.$.colors.bg, 0.15), -0.05)
  activeHoverStyle = saturate(luminate(skin.$.colors.bg, 0.45), -0.25)

  draw = (
    c: CanvasRenderingContext2D,
    x: number,
    y: number,
    w: number,
    h: number
  ) => {
    c.save()

    c.translate(x, y)

    const { active, hover, value, min, max, step, rect: r } = this

    const fillStyle = active ? this.activeFillStyle : '#f61'
    c.lineWidth = 1 //active ? 1 : hover ? 0.75 : 0.1
    c.strokeStyle = active ? fillStyle : hover ? this.activeHoverStyle : this.activeStrokeStyle
    c.fillStyle = luminate(skin.$.colors.bg, -0.015)
    c.fillRect(0, 0, w, h)
    c.strokeRect(0, 0, w, h)

    r.x = r.y = 0
    r.width = w
    r.height = h
    // r.zoomLinearSelf(-4)

    // c.globalCompositeOperation = 'hard-light'
    c.strokeStyle = c.fillStyle = fillStyle //'#f61' //['#f70', '#07f', '#0b0', '#bb0', '#f0f'].at(Math.random() * 5 | 0)
    c.lineWidth = 1 //.75

    const scale = max - min
    const stepScaled = step / scale
    const steps = (scale - step) / step
    const width = (r.width / steps) * (steps + 1)
    const co = width / r.width
    r.width *= Math.floor(Math.max(0, Math.min(0.999999, value)) / stepScaled) * stepScaled * co

    r.y = Math.round(r.y)
    r.width = Math.round(r.width)
    r.height = Math.round(r.height)

    c.fillRect(
      r.x,
      r.y,
      r.width,
      r.height
    )

    // let i = 0
    // c.lineWidth = 3
    // c.strokeStyle = '#000'
    // users.forEach((user) => {
    //   if (user.param === index) {
    //     const idle = performance.now() - user.time
    //     if (idle < 250) active = true
    //     else active = false
    //     const opacity = 1 - (Math.min(1, idle / USER_IDLE_MS) ** 2)
    //     const alpha = Math.round(opacity * 255).toString(16).padStart(2, '0')
    //     c.beginPath()
    //     c.arc(
    //       (i++ * 20) + 2,
    //       h + 2.5,
    //       8,
    //       0,
    //       Math.PI * 2
    //     )
    //     c.fillStyle = user.color + alpha
    //     c.fill()
    //     c.strokeStyle += alpha
    //     c.stroke()
    //   }
    // })

    // this.active = active

    c.restore()
  }
}
